const utils = require('../../../lib/utils')
const instantImageUploaderController = require('../../../lib/controllers/modals/instantImageUploader')

module.exports = {
	config: {
		maxParallelRenderCalls: 5,
		initDraggables: true,
		draggable: {
			durations: {
				moveElement: .3
			}
		}
	},

	model: {
		tagPickerButton: false,
	},

	events: {
		openImageManagement: {
			type: 'click',
			selector: 'button.base_form_fields_image-button',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				event.data.component.openImageManagement();
			}
		},

		singleImageAction: {
			type: 'click',
			selector: '.base_form_media_image_image button',
			action: function(event){
				var mediaID = $(event.target).closest('.base_form_media_image_image').data('mediaId');
				if(mediaID){
					event.preventDefault();
					event.stopImmediatePropagation();
					utils.performButtonAction(event, undefined, { mediaID: mediaID });
				}
			}
		},

		allImagesAction: {
			type: 'click',
			selector: 'button.base_form_elements_buttons_default',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();
				utils.performButtonAction(event, undefined, { operateOnAllImages: true });
			}
		}
	},

	methods: {

		showEdit(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			let mediaID = (additionalData || {}).mediaID;
			if(!mediaID && additionalData.operateOnAllImages){
				mediaID = this.getFirstMediaIDIfSingle()
			}

			if(mediaID) {
				const entity = utils.media.getMediaDataByID(this.model.dataJSON, mediaID)
				return this.performAction(
					this.prepareAction('imageAssignmentDetails', mediaID, {
						imageAssignmentDetails: entity
					})
				)
			}

			return utils.promise.reject();
		},

		renew(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			if(utils.isEmpty(this.model.dataJSON)){
				return
			}

			additionalData = additionalData || {}
			const fieldConfig = this.model.config || {}
			const entity = utils.media.getMediaDataByID(this.model.dataJSON, additionalData.mediaID);
			if(entity && entity.index !== undefined){
				const assignedEntity = this.model.dataJSON[entity.index]
				if(assignedEntity.renew){
					assignedEntity.renew = false
				}
				else {
					assignedEntity.renew = true
					assignedEntity.delete = false
				}

				// check if config prevents some user decisions (like maxNrOfElements limit reached, ...)
				this.reworkImageList(fieldConfig.managementConfig, entity.index)
			}
			else if(additionalData.operateOnAllImages) {
				let renewAll = true
				for(const assignedEntity of Object.values(this.model.dataJSON)){
					if(!assignedEntity.missingMainDBEntry){
						renewAll &= !!assignedEntity.renew
						if(!renewAll){
							break
						}
					}
				}

				let newRenewState = !renewAll
				for(const assignedEntity of Object.values(this.model.dataJSON)){
					// prevent trying missingMainDBEntry renew operations
					if(!assignedEntity.missingMainDBEntry){
						assignedEntity.renew = newRenewState
						if(newRenewState){
							assignedEntity.delete = false
						}
					}
				}

				// check if config prevents some user decisions (like maxNrOfElements limit reached, ...)
				this.reworkImageList(fieldConfig.managementConfig)
			}
		},

		delete(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			if(utils.isEmpty(this.model.dataJSON)){
				return
			}

			additionalData = additionalData || {}
			const fieldConfig = this.model.config || {}
			const entity = utils.media.getMediaDataByID(this.model.dataJSON, additionalData.mediaID);
			if(entity && entity.index !== undefined){
				const assignedEntity = this.model.dataJSON[entity.index]
				if(assignedEntity.delete){
					assignedEntity.delete = false
				}
				else {
					assignedEntity.delete = true
					assignedEntity.renew = false
					assignedEntity.pause = false
				}

				// check if config prevents some user decisions (like maxNrOfElements limit reached, ...)
				this.reworkImageList(fieldConfig.managementConfig, entity.index)
			}
			else if(additionalData.operateOnAllImages) {
				let deleteAll = true
				for(const assignedEntity of Object.values(this.model.dataJSON)){
					deleteAll &= !!assignedEntity.delete
					if(!deleteAll){
						break
					}
				}

				let newDeleteState = !deleteAll
				for(const assignedEntity of Object.values(this.model.dataJSON)){
					assignedEntity.delete = newDeleteState
					if(newDeleteState){
						assignedEntity.renew = false
						assignedEntity.pause = false
					}
				}

				// check if config prevents some user decisions (like maxNrOfElements limit reached, ...)
				this.reworkImageList(fieldConfig.managementConfig)
			}
		},

		pause(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			if(utils.isEmpty(this.model.dataJSON)){
				return
			}

			additionalData = additionalData || {}
			const fieldConfig = this.model.config || {}
			const entity = utils.media.getMediaDataByID(this.model.dataJSON, additionalData.mediaID);
			if(entity && entity.index !== undefined){
				const assignedEntity = this.model.dataJSON[entity.index]
				if(assignedEntity.pause){
					assignedEntity.pause = false
				}
				else {
					assignedEntity.pause = true
					assignedEntity.renew = false
					assignedEntity.delete = false
				}
				assignedEntity.pauseChanged = !Boolean(assignedEntity.pauseChanged)

				// check if config prevents some user decisions (like maxNrOfElements limit reached, ...)
				this.reworkImageList(fieldConfig.managementConfig, entity.index)
			}
			else if(additionalData.operateOnAllImages) {
				let pauseAll = true
				for(const assignedEntity of Object.values(this.model.dataJSON)){
					pauseAll &= !!assignedEntity.pause
					if(!pauseAll){
						break
					}
				}

				let newPauseState = !pauseAll
				for(const assignedEntity of Object.values(this.model.dataJSON)){
					assignedEntity.pause = newPauseState
					assignedEntity.pauseChanged = true
					if(newPauseState){
						assignedEntity.renew = false
						assignedEntity.delete = false
					}
				}

				// check if config prevents some user decisions (like maxNrOfElements limit reached, ...)
				this.reworkImageList(fieldConfig.managementConfig)
			}
		},

		copyToClipboardUrl(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			let mediaID = (additionalData || {}).mediaID;
			if(!mediaID && additionalData.operateOnAllImages){
				mediaID = this.getFirstMediaIDIfSingle()
			}

			if(mediaID){
				const entity = utils.media.getMediaDataByID(this.model.dataJSON, mediaID)
				if(entity.url){
					utils.copyToClipboard(entity.url)
				}
			}
		},

		open(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			let mediaID = (additionalData || {}).mediaID, mediaUrl
			if(!mediaID && additionalData.operateOnAllImages){
				mediaID = this.getFirstMediaIDIfSingle()
			}

			if(mediaID){
				const entity = utils.media.getMediaDataByID(this.model.dataJSON, mediaID)
				if(entity.url){
					mediaUrl = entity.url
				}
			}

			if(mediaUrl){
				window.open(mediaUrl, '_blank').focus()
			} else {
				this.performMessage({
					messageDisplay: {
						message: 'error:imageManagement.cannotOpenMissingImage.message'
					}
				})
			}
		},

		filter: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			this.openImageManagement(true);
		},

		closeFullScreen: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			this.fullScreen(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData);
		},

		fullScreen: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			if(this.model.fullScreen){
				this.model.fullScreen = false;
				this.$.closest('.base_tabStrip_tabContent, .base_modal_modal > .window > .body').find('.fullScreenHidden').removeClass('fullScreenHidden');
				this.$.closest('.base_tabStrip_tabContent, .base_modal_modal > .window > .body').find('.fullScreen').removeClass('fullScreen');
			} else {
				this.model.fullScreen = true;
				this.$.find('*').addClass('fullScreen');
				this.$.parentsUntil('.base_tabStrip_tabContent, .base_modal_modal > .window > .body').addClass('fullScreen');
				this.$.closest('.base_tabStrip_tabContent, .base_modal_modal > .window > .body').find('*:not(.fullScreen)').addClass('fullScreenHidden');
			}

			this.refresh();
		},

		async showAssign(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			if(buttonContext === 'tags'){
				let mediaID = (additionalData || {}).mediaID;
				if(!mediaID && additionalData.operateOnAllImages){
					mediaID = this.getFirstMediaIDIfSingle()
				}

				if(mediaID) {
					const media = await this.getCategorizedMedia(mediaID)
					const cmsEntitiesCategories = utils.simpleCopy((media.children || {}).cms_entities_categories || {})
					utils.media.image.prepare(media, storage, 'web', this.scope)
					this.openTagAssignment([mediaID], cmsEntitiesCategories, 'showTagAssignmentMediaEnhanced', media);
					return
				}
			}

			return utils.promise.reject();
		},

		openTagAssignment: function(mediaIDs, cmsEntitiesCategories, overrideAction, media){
			var self = this;
			self.model.assignTagsToMedia = {
				mediaIDs: mediaIDs,
				cmsEntitiesCategories: cmsEntitiesCategories
			};

			if(!self.model.tagPickerButton){
				self.furthest('base_form_form', undefined, function(form){
					form.find('base_form_fields_tag-picker-button', function(tagPickerButton){
						if(tagPickerButton.model.fieldCode === '_internalMediaTags'){
							self.model.tagPickerButton = tagPickerButton
						}
					});
				});
			}

			if(self.model.tagPickerButton){
				self.model.tagPickerButton.open((cmsEntitiesCategories || {}).data || [], function(options){
					// submit image details and tag-assignments if necessary
					const decisionType = (options.decisionOptions || {}).decisionType || 'cancel'
					if(options.enhancementComponent && decisionType !== 'cancel' && decisionType !== 'close' && decisionType !== 'done'){
						self.onTagsPicked(options);
						options.enhancementComponent.submit();
					}
				}, overrideAction, media);
			}
		},

		onTagsPicked: function(options){
			var self = this;
			var dirtyAssignedTags, dat, media, mediaID, mediaIDs, mediaIndex;
			var tagsToUpdate = [];
			if(
				(dirtyAssignedTags = ((options || {}).decisionOptions || {}).dirtyAssignedTags || {})
				&&
				(media = self.model.assignTagsToMedia || {})
				&&
				(mediaIDs = media.mediaIDs)
			){
				for(mediaIndex in mediaIDs){
					for(dat in dirtyAssignedTags){
						tagsToUpdate.push({
							type: dirtyAssignedTags[dat].type === 'delete' ? 'delete' : undefined,
							attributes: {
								entityCategoryID: 	dirtyAssignedTags[dat].entityCategoryID || dirtyAssignedTags[dat].id,

								entityID: 			mediaIDs[mediaIndex],
								entityType: 		options.categoryEntityType,
								categoryID: 		dirtyAssignedTags[dat].categoryID,
								categoryDataID: 	dirtyAssignedTags[dat].categoryDataID,
								enabled: 			dirtyAssignedTags[dat].enabled
							}
						});
					}
				}
			}

			if(tagsToUpdate.length > 0){
				self.performAction(
					self.prepareAction('updateTagAssignments', undefined, undefined, {
						source: {
							submit: {
								data: {
									data: tagsToUpdate
								}
							}
						}
					})
				).then(function(context){
					var statusController;
					if((statusController = getComponent('statusController'))) {
						statusController.addPanel('status.done.assigned');
					}
				})
			}
		},

		getCategorizedMedia: function(mediaID){
			var self = this;
			if(mediaID){
				return self.performAction(
					self.prepareAction('getCategorizedMedia', undefined, undefined, {
						source: {
							load: {
								resourceFilters: {
									listOfMediaIDs: [mediaID]
								}
							}
						}
					})
				).then(function(context){
					return utils.promise.resolve(((((context || {}).action || {}).response || {}).data || [])[0]);
				})
			}

			return utils.promise.reject();
		},

		getFirstMediaIDIfSingle(){
			const fieldConfig = this.model.config || {}
			const managementConfig = fieldConfig.managementConfig || {}
			if(managementConfig.multiSelect === false || managementConfig.maxNrOfElements <= 1){
				for(const entity of Object.values(this.model.dataJSON || {})){
					if(!entity.delete){
						return entity.mediaID
					}
				}
			}
		},

		prepare: function(){
			this.model.extendedButtonActionsGranted = this.hasAccessTo('usage:media:extendedButtonActions', this.scope)

			const fieldConfig = this.model.config || {}
			const managementConfig = fieldConfig.managementConfig || {}
			if(fieldConfig.initDraggables === false || managementConfig.multiSelect === false || managementConfig.maxNrOfElements <= 1){
				this.config.initDraggables = false
			}
		},

		onChange: function(value){
			var self = this;
			var promise;

			this.model.dataJSON = value;

			// tell parent form that something has been changed
			this.parent(function(parentComponent){
				promise = parentComponent.trigger('onChildChanged', {
					fieldCode:  self.model.fieldCode,
					value:      value
				});
			});

			if(!promise) promise = utils.promise.resolve();
			return promise;
		},

		onBeforeRender: function(){
			var self = this;
			var imageIndex;
			var realIndex = -1;
			// set index and correct index gaps if necessary
			self.model.indexGapFound = false;
			for(imageIndex of Object.keys(this.model.dataJSON || {})){
				if(this.model.dataJSON[imageIndex]){
					realIndex++;
					if(!self.model.dataJSON[imageIndex].index || self.model.dataJSON[imageIndex].index != realIndex) self.model.dataJSON[imageIndex].index = realIndex;
					if(realIndex != imageIndex){
						self.model.indexGapFound = true;
						self.model.dataJSON[realIndex] = self.model.dataJSON[imageIndex];
						delete self.model.dataJSON[imageIndex];
					}
				}
			}
		},

		prepareRenderCalls: function(image){
			var self = this;
			var calls = [];
			if(!this.config.serviceMediaConfig){
				const storage = this.getStorage()
				this.config.serviceMediaConfig 		= storage.app.webService.config.media;
			}
			var renderConfigs = utils.media.image.prepareRenderConfigs(image, this.model.config, this.config.serviceMediaConfig, this.activeEnvironment);

			if(renderConfigs.length > 0){
				utils.forEach(renderConfigs, function(renderConfig){
					calls.push(function(){ return self.performAction(
						self.prepareAction(
							'renderMedia',
							undefined,
							undefined,
							{
								statusControllerLoadingMessage: '',
								statusControllerSavingMessage:  '',
								source: {
									submit: {
										data: {
											data: renderConfig
										}
									}
								}
							}
						)
					).then(function(context){
						var response = context.response.data;
						var nrOfAddedRenderedMedia = 0;
						var data = Array.isArray(response) ? response : [response];
						var nrOfElements = data.length;
						utils.forEach(data, function(renderedMedia, renderedMediaIndex){
							if(renderedMedia.mediaID){
								utils.forEach(self.model.dataJSON, function(media, index){
									if(media.mediaID === renderedMedia.mediaID && media.rendered && Array.isArray(media.rendered)){
										nrOfAddedRenderedMedia++;
										self.model.dataJSON[index].rendered.push({
											mediaRenderedID: renderedMedia.mediaRenderedID
										});
										return false;
									}
								});
							}
						});
						if(nrOfAddedRenderedMedia !== nrOfElements){
							console.error('at least one rendered image has not been added to rendered image list');
						}
					})});
				});
			}

			return calls;
		},

		prepareForSubmit: function(){
			var self = this;
			var prepareImagePromises = [];
			var imageDataChanged = !!self.model.indexGapFound || !!self.model.orderChanged;

			// correct index positions if necessary
			prepareImagePromises.push(function(){ return self.refreshOrder; });

			// check if config prevents some user decisions (like maxNrOfElements limit reached, ...)
			var managementConfig = {};
			if(this.model.config) managementConfig = this.model.config.managementConfig;
			self.reworkImageList(managementConfig, false);

			var deletionCounter = 0;
			var originalDataJSON = utils.simpleCopy(this.model.dataJSON);
			utils.forEach(this.model.dataJSON, function(image, index){
				index = parseInt(index);

				if(image.delete){
					delete self.model.dataJSON[index];
					deletionCounter++;
					imageDataChanged = true;
				}
				else if(image.readyToRender || image.renew){
					self.model.dataJSON[index].rendered = [];
					imageDataChanged = true;
					prepareImagePromises = prepareImagePromises.concat(self.prepareRenderCalls(image));
				}
				else if(image.pauseChanged){
					imageDataChanged = true;
				}

				if(self.model.dataJSON[index]){
					self.model.dataJSON[index] = utils.media.image.cleanupElementBeforeSet(self.model.dataJSON[index]);

					// do some index corrections
					if(deletionCounter > 0){
						self.model.dataJSON[index-deletionCounter] = self.model.dataJSON[index];
						delete self.model.dataJSON[index];
					}
				}
			});

			// build chains to prevent timeouts on big amounts of parallel render calls
			var nrOfPromises = prepareImagePromises.length || 0;
			if(nrOfPromises < 1) return Promise.resolve({});
			var maxNumberOfParallelRenderCalls = this.config.maxParallelRenderCalls || 5;
			var chainedPromises = {
				'0': []
			}
			var i, chainLinkIndex = 0;
			for(i = 0; i < nrOfPromises; i++){
				chainedPromises[String(chainLinkIndex)].push(prepareImagePromises[i]);
				if((i % maxNumberOfParallelRenderCalls) === 0){
					chainLinkIndex++;
					chainedPromises[String(chainLinkIndex)] = [];
				}
			}

			var statusController = getComponent('statusController');
			if(statusController){
				statusController.showStatus('status.progress.save');
			}
			return utils.promise.performAllChains(this, chainedPromises)
				.fail(function(error){
					if(statusController){
						statusController.removeStatus();
					}
					// if some render process fails refresh form and let it go
					self.furthest('base_form_form', undefined, function(mainForm){
						mainForm.refresh();
					});
				})
				.then(function(){
					if(statusController){
						statusController.removeStatus();
					}
					if(prepareImagePromises.length > 0){
						utils.map(self.model.dataJSON, function(image){
							delete image.readyToRender;
							delete image.renew;
							return image;
						});

						var result;
						if(imageDataChanged){
							self.parent(function(parentComponent){
								result = parentComponent.trigger('onChildChanged', {
									fieldCode:  self.model.fieldCode,
									value:      self.model.dataJSON || {}
								});
							});
						}
						else {
							self.model.dataJSON = utils.simpleCopy(originalDataJSON);
							result = utils.promise.resolve();
						}

						return result;
					}

					return {};
				})
			;
		},

		reworkImageList: function(managementConfig, bossMediaIndex, refreshDOMClasses){
			managementConfig = managementConfig || {};
			var maxNrOfElements = Number.MAX_SAFE_INTEGER;
			var nrOfElements = utils.collectionSize(this.model.dataJSON);
			var mediaIndex;
			if(refreshDOMClasses === undefined) refreshDOMClasses = true;
			if(managementConfig.multiSelect === false || managementConfig.maxNrOfElements <= 1){
				maxNrOfElements = 1;
			}
			else if(managementConfig.maxNrOfElements > 1){
				maxNrOfElements = managementConfig.maxNrOfElements;
			}
			var nrOfElementsReadyForDeletion = 0;
			var mediaKeys = Object.keys(this.model.dataJSON || {});
			for(mediaIndex = 0; mediaIndex < nrOfElements; mediaIndex++){
				if(this.model.dataJSON[mediaKeys[mediaIndex]].delete){
					nrOfElementsReadyForDeletion++;
				}
			}
			var realMediaIndex = -1;
			for(mediaIndex = 0; mediaIndex < (nrOfElements - nrOfElementsReadyForDeletion - maxNrOfElements); mediaIndex++){
				do {
					realMediaIndex++;
					if(!this.model.dataJSON[mediaKeys[realMediaIndex]].delete && realMediaIndex != bossMediaIndex){
						this.model.dataJSON[mediaKeys[realMediaIndex]].delete = true;
						this.model.dataJSON[mediaKeys[realMediaIndex]].renew = false;
						this.model.dataJSON[mediaKeys[realMediaIndex]].pause = false;
						break;
					}
				} while(realMediaIndex < nrOfElements);
			}

			this.refreshDirtyStatus();
			if(refreshDOMClasses) this.refreshDOMClasses();
		},

		refreshDOMClasses: function(){
			var mediaID, mediaIndex, image, $target;
			var stateClasses = 'delete renew pause';
			var isDirty = false;
			this.$.removeClass('dirty');
			for(mediaIndex in this.model.dataJSON){
				image = this.model.dataJSON[mediaIndex];
				mediaID = image.mediaID;
				$target = this.$.find('[data-media-id="' + this.model.dataJSON[mediaIndex].mediaID + '"]').removeClass(stateClasses);
				if(image.delete) {
					$target.addClass('delete');
					isDirty = true;
				}
				else if(image.renew) {
					$target.addClass('renew');
					isDirty = true;
				}
				else if(image.pause) {
					$target.addClass('pause');
					isDirty = true;
				}
			}

			if(isDirty) this.$.addClass('dirty');
		},

		refreshDirtyStatus: function(){
			var mediaIndex, image;
			this.model.isDirty = false;
			for(mediaIndex in this.model.dataJSON){
				image = this.model.dataJSON[mediaIndex];
				if(image.delete || image.renew || image.pause || image.readyToRender) {
					this.model.isDirty = true;
					break;
				}
			}

			if(this.model.isDirty) 	this.$.addClass('isDirty');
			else 					this.$.removeClass('isDirty');
		},

		initDraggables: function($element){
			if(!this.config.initDraggables || typeof Draggable === 'undefined') return;

			this.model.draggable = {};
			this.model.draggable.$container = $element.find('.media');
			this.model.draggable.$elements = this.model.draggable.$container.find('.base_form_media_image_image');
			this.model.draggable.container = {
				width:  this.model.draggable.$container.width(),
				height: this.model.draggable.$container.height()
			};
			this.model.draggable.elements = {
				width:  this.model.draggable.$elements.first().outerWidth(true),
				height: this.model.draggable.$elements.first().outerHeight(true)
			};
			this.model.draggable.dirtyElements      = {};
			this.model.draggable.dirtyElementsMove  = {};
			this.model.draggable.finalDirtyElements = {};
			this.model.draggable.resetElements      = {};
			this.model.draggable.indexMapping = {};
			this.model.draggable.nrOfElements       = this.model.draggable.$elements.length;
			this.model.draggable.nrOfElementsPerRow = parseInt(this.model.draggable.container.width / this.model.draggable.elements.width);
			this.model.draggable.nrOfRows           = this.model.draggable.nrOfElements / this.model.draggable.nrOfElementsPerRow;
			var nrOfRows;
			if((nrOfRows = parseInt(this.model.draggable.nrOfRows)) < this.model.draggable.nrOfRows){
				this.model.draggable.nrOfRows = ++nrOfRows;
			}

			this.model.draggable.initialized = true;
			this.model.draggable.started = false;

			Draggable.create(
				this.model.draggable.$elements,
				{
					bounds:             this.model.draggable.$container,
					cursor:             'pointer',
					minimumMovement:    6,
					onClick:            this.onClick,
					onClickParams:      [this],
					onDragStart:        this.onDragStart,
					onDragStartParams:  [this],
					onDrag:             this.onDrag,
					onDragParams:       [this],
					onDragEnd:          this.onDragEnd,
					onDragEndParams:    [this],
					onRelease:          this.onRelease,
					onReleaseParams:    [this]
				}
			);
		},

		onClick: function(component){
			$(this.target).css('z-index', 'initial');
		},

		onDragStart: function(component){
			if(component.model.draggable.initialized){
				component.model.draggable.started = true;
				var $target = $(this.target);
				$target.addClass('dragInCharge');
				var index = parseInt($target.attr('data-media-index'));
				var i = component.model.dataJSON[index].index;
				component.model.draggable.dirtyElements[index]      = {};
				component.model.draggable.dirtyElementsMove[index]  = {};
				if(component.model.draggable.finalDirtyElements[index] == undefined){
					component.model.draggable.finalDirtyElements[index] = {};
				}
				component.model.draggable.resetElements[index]      = {};
				component.model.draggable.position = {
					index:  index,
					row:    parseInt(index / component.model.draggable.nrOfElementsPerRow),
					col:    (index % component.model.draggable.nrOfElementsPerRow),
					i:      i,
					r:      parseInt(i / component.model.draggable.nrOfElementsPerRow),
					c:      (i % component.model.draggable.nrOfElementsPerRow)
				};
			}
		},
		onDrag: function(component){
			if(component.model.draggable.initialized && component.model.draggable.started){
				var pos             = component.model.draggable.position || {};
				var dirties         = component.model.draggable.dirtyElements[pos.index];
				var dirtyIndexes    = Object.keys(dirties);

				var offset = {
					r: this.y / component.model.draggable.elements.height,
					c: this.x / component.model.draggable.elements.width,
					rows: Math.round(this.y / component.model.draggable.elements.height),
					cols: Math.round(this.x / component.model.draggable.elements.width)
				};
				offset.index = (offset.rows * component.model.draggable.nrOfElementsPerRow);
				offset.index += offset.cols;

				// correct offset boundaries
				offset.index    = Math.max(-pos.index,          Math.min(offset.index,    component.model.draggable.nrOfElements - 1 - pos.index));
				offset.rows     = Math.max(1 - component.model.draggable.nrOfRows,              Math.min(offset.rows,     component.model.draggable.nrOfRows - 1));
				offset.cols     = Math.max(1 - component.model.draggable.nrOfElementsPerRow,    Math.min(offset.cols,     component.model.draggable.nrOfElementsPerRow - 1));
				if((pos.row + offset.rows) == (component.model.draggable.nrOfRows - 1)){
					offset.cols = Math.min(offset.cols, ((component.model.draggable.nrOfElements - 1) % component.model.draggable.nrOfElementsPerRow) - pos.col);
				}



				// animation necessary
				if(offset.rows != 0 || offset.cols != 0 || pos.i != pos.index || dirtyIndexes.length > 0){

					var start, end, row, col, i, r, c;
					var indexes = {
						left: {},
						leftDown: {},
						right: {},
						rightUp: {},
						reset: {}
					};
					var indexesRelative = {
						left: {},
						leftDown: {},
						right: {},
						rightUp: {},
						reset: {}
					};
					var indexesLength = {
						left: 0,
						leftDown: 0,
						right: 0,
						rightUp: 0,
						reset: 0
					};
					var lastCol = component.model.draggable.nrOfElementsPerRow - 1;
					if((pos.index + offset.index) > pos.i){
						start = {
							index: pos.i,
						};
						start.row = pos.r;
						start.col = pos.c;
						end     = {
							index:  pos.index + offset.index,
							row:    pos.row + offset.rows,
							col:    pos.col + offset.cols
						};
					}
					else {
						end = {
							index: pos.i,
						};
						end.row = pos.r;
						end.col = pos.c;
						start   = {
							index:  pos.index + offset.index,
							row:    pos.row + offset.rows,
							col:    pos.col + offset.cols
						};
					}

					var index = start.index;
					var dirtyInCharge = false;
					var checkingDirties = false;
					var mappingIndex;
					var isRelative;

					for(r = start.row; r <= (end.row + dirtyIndexes.length); r++){
						for(c = 0; c < component.model.draggable.nrOfElementsPerRow; c++) {
							// within range?
							if(r == start.row && c < start.col){
								continue;
							}
							else if(r == end.row && c > end.col){
								break;
							}
							// handle dirties of last onDrag call
							else if(r > end.row){
								checkingDirties = true;
								i = dirtyIndexes[(r - end.row - 1)];
								mappingIndex = dirties[i];
								dirtyInCharge = dirties[i] !== undefined;
							}
							// set actual row and col
							else {
								// set index to actual elements index
								if(component.model.draggable.indexMapping[index] !== undefined){
									mappingIndex = component.model.draggable.indexMapping[index];
								}
								else {
									mappingIndex = index;
								}
								i = (component.model.dataJSON[mappingIndex] || {}).index;
								row = r;
								col = c;
							}

							if(index != pos.i){
								if(dirtyInCharge){
									if(dirties[i] !== undefined){
										// reset
										indexes.reset[i] = mappingIndex;
										indexesLength.reset++;
									}
								}
								else if(!checkingDirties){
									// reset dirty
									delete dirties[i];

									if(row < pos.row){
										if(col == lastCol){
											// left down
											indexes.leftDown[i] = mappingIndex;
											indexesLength.leftDown++;
										}
										else {
											// right
											indexes.right[i] = mappingIndex;
											indexesLength.right++;
										}
									}
									else if(row > pos.row){
										if(col == 0){
											// right up
											indexes.rightUp[i] = mappingIndex;
											indexesRelative.rightUp[i] = isRelative;
											indexesLength.rightUp++;
										}
										else {
											// left
											indexes.left[i] = mappingIndex;
											indexesLength.left++;
										}
									}
									else {
										if(col < pos.col){
											// right
											indexes.right[i] = mappingIndex;
											indexesLength.right++;
										}
										else if(col > pos.col) {
											// left
											indexes.left[i] = mappingIndex;
											indexesLength.left++;
										}
										else {
											// force original position
											indexes.reset[i] = mappingIndex;
											indexesLength.reset++;
										}
									}
								}
							}

							if(checkingDirties) break;
							index++;
						}
					}

					var properties, move, selectors, selector, finalIndexOffset;
					component.model.draggable.dirtyElements[pos.index]      = {};
					for(move in indexes){
						if(indexesLength[move] > 0){
							finalIndexOffset = 0;
							if(move === 'left'){
								finalIndexOffset    = -1;
							}
							else if(move === 'right'){
								finalIndexOffset    = 1;
							}
							else if(move === 'leftDown'){
								finalIndexOffset    = 1;
							}
							else if(move === 'rightUp'){
								finalIndexOffset    = -1;
							}


							if(move != 'reset'){
								for(i in indexes[move]){
								    i = parseInt(i);
									component.model.draggable.dirtyElements[pos.index][i]                       = indexes[move][i];
									component.model.draggable.dirtyElementsMove[pos.index][indexes[move][i]]    = finalIndexOffset;
									component.model.draggable.finalDirtyElements[pos.index][indexes[move][i]]   = (i + finalIndexOffset);
								}
							}
							else {
								var lastFinalIndexOffset;
								for(i in indexes[move]) {
									i = parseInt(i);
									if(component.model.draggable.dirtyElementsMove[pos.index][indexes[move][i]] !== undefined){
										component.model.draggable.dirtyElementsMove[pos.index][indexes[move][i]] *= -1;
										lastFinalIndexOffset = component.model.draggable.dirtyElementsMove[pos.index][indexes[move][i]];
										component.model.draggable.finalDirtyElements[pos.index][indexes[move][i]] = (i + lastFinalIndexOffset);
									}
									else {
										component.model.dataJSON[indexes[move][i]].indexOffset = 0;
										component.model.draggable.finalDirtyElements[pos.index][indexes[move][i]] = (i + 0);
									}
								}
							}

							selectors = {};
							var indexOffset;
							for(i in indexes[move]){
								mappingIndex = indexes[move][i];
								indexOffset = (component.model.dataJSON[mappingIndex].indexOffset || 0) + finalIndexOffset;

								if(selectors[mappingIndex] == undefined) selectors[mappingIndex] = {};
								if(selectors[mappingIndex][indexOffset] == undefined) selectors[mappingIndex][indexOffset] = '';
								selectors[mappingIndex][indexOffset] += '[data-media-index="' + mappingIndex + '"],';
							}

							var newRow, newCol;
							for(mappingIndex in selectors){
								for(indexOffset in selectors[mappingIndex]){
									selector = selectors[mappingIndex][indexOffset];
									if(selector != ''){
										mappingIndex = parseInt(mappingIndex);
										indexOffset = parseInt(indexOffset);
										index = mappingIndex + indexOffset;
										i = mappingIndex;
										selector = selector.replace(/,$/, '');

										newRow = parseInt(index / component.model.draggable.nrOfElementsPerRow);
										newCol = (index % component.model.draggable.nrOfElementsPerRow);
										row = parseInt(i / component.model.draggable.nrOfElementsPerRow);
										col = (i % component.model.draggable.nrOfElementsPerRow);

										r = newRow - row;
										c = newCol - col;

										properties = {
											x:   (c * component.model.draggable.elements.width),
											y:    (r * component.model.draggable.elements.height)
										};

										component.model.draggable.$elements.filter(selector).each(function(){
											TweenMax.to(
												this,
												component.config.draggable.durations.moveElement,
												properties
											);
										});
									}
								}
							}
						}
					}
				}
			}
		},
		onDragEnd: function(component){
			if(component.model.draggable.initialized && component.model.draggable.started){
				$(this.target).removeClass('dragInCharge');
			}
		},
		onRelease: function(component){
			if(component.model.draggable.initialized && component.model.draggable.started){
				component.model.draggable.initialized = false;

				var pos = component.model.draggable.position || {};

				// calculate offset
				var offset = {
					rows: Math.round(this.y / component.model.draggable.elements.height),
					cols: Math.round(this.x / component.model.draggable.elements.width)
				};
				offset.index = (offset.rows * component.model.draggable.nrOfElementsPerRow);
				offset.index += offset.cols;

				// correct offset boundaries
				offset.index    = Math.max(-pos.index,          Math.min(offset.index,    component.model.draggable.nrOfElements - 1 - pos.index));
				offset.rows     = Math.max(1 - component.model.draggable.nrOfRows,              Math.min(offset.rows,     component.model.draggable.nrOfRows - 1));
				offset.cols     = Math.max(1 - component.model.draggable.nrOfElementsPerRow,    Math.min(offset.cols,     component.model.draggable.nrOfElementsPerRow - 1));
				if((pos.row + offset.rows) == (component.model.draggable.nrOfRows - 1)){
					offset.cols = Math.min(offset.cols, ((component.model.draggable.nrOfElements - 1) % component.model.draggable.nrOfElementsPerRow) - pos.col);
				}

				// update target position
				var $target = $(this.target);
				TweenMax.to(
					$target,
					component.config.draggable.durations.moveElement,
					{
						x:  (offset.cols * component.model.draggable.elements.width),
						y:  (offset.rows * component.model.draggable.elements.height),
						onComplete: function(){
							$target.css('z-index', 'initial');
							component.refresh();
						}
					}
				);

				// correct reset indexes if necessary
				var index, i;
				var dirtyMoves = component.model.draggable.dirtyElementsMove[pos.index];

				var targetIndex = pos.index + offset.index;
				var finalDirties = component.model.draggable.finalDirtyElements[pos.index];
				if(pos.i < targetIndex){
					for(index in finalDirties){
						i = parseInt(finalDirties[index]);
						if(i >= pos.i && i <= targetIndex){
							if(!component.model.dataJSON[index].indexOffset){
								component.model.dataJSON[index].indexOffset = 0;
							}

							if(dirtyMoves[index]){
								component.model.dataJSON[index].indexOffset += dirtyMoves[index];
							}

							component.model.dataJSON[index].index = parseInt(index) + component.model.dataJSON[index].indexOffset;
							component.model.draggable.indexMapping[component.model.dataJSON[index].index] = parseInt(index);
						}
					}
				}
				else if(pos.i > targetIndex){
					for(index in finalDirties){
						i = parseInt(finalDirties[index]);
						if(i >= targetIndex && i <= pos.i){
							component.model.dataJSON[index].index = parseInt(i);
							if(!component.model.dataJSON[index].indexOffset){
								component.model.dataJSON[index].indexOffset = 0;
							}

							if(dirtyMoves[index]){
								component.model.dataJSON[index].indexOffset += dirtyMoves[index];
							}

							component.model.dataJSON[index].index = parseInt(index) + component.model.dataJSON[index].indexOffset;
							component.model.draggable.indexMapping[component.model.dataJSON[index].index] = parseInt(index);
						}
					}
				}
				component.model.dataJSON[pos.index].index = targetIndex;
				component.model.dataJSON[pos.index].indexOffset = targetIndex - pos.index;
				component.model.draggable.indexMapping[targetIndex] = pos.index;

				component.refreshOrder();
				component.model.orderChanged = true;
				component.model.draggable.started = false;
			}
		},

		refreshOrder: function(forceOnChange){
			// correct index positions if necessary
			var dataJSON = {};
			var changedIndexFound = false;
			var self = this;
			utils.forEach(this.model.dataJSON, function(image, index){
				if(image.index === undefined){
					self.model.dataJSON[index].index = index;
					image.index = index;
				}
				changedIndexFound = changedIndexFound || index != image.index;
				image.indexOffset = 0;
				dataJSON[image.index] = image;
			});
			if(changedIndexFound || forceOnChange) return this.onChange(dataJSON);
			return utils.promise.resolve();
		},

		openImageManagement: function(filterMediaIDs){
			const fieldConfig = this.model.config || {}

			// root-parent forms get to override ownerships
			if(!this.model.owner){
				this.parentComponents('base_form_form', form => {
					if(form.$ && form.$.is('form')){
						this.model.owner = form.getOwner()
						return false
					}
				})
			}
			const owner = this.model.owner

			let listOfMediaIDs;
			if(filterMediaIDs) {
				const mediaIDs = {}
				utils.forEach(this.model.dataJSON, function(media, index){
					mediaIDs[media.mediaID] = true
				});
				listOfMediaIDs = Object.keys(mediaIDs)
			}

			let modalSubTitle = 'modal.imageManagement.subTitle.multiSelect'
			const managementConfig = fieldConfig.managementConfig || {}
			if(managementConfig.multiSelect === false || managementConfig.maxNrOfElements <= 1){
				modalSubTitle = 'modal.imageManagement.subTitle.singleSelect'
			}

			if(fieldConfig.instantUpload){
				if(!utils.isCollection(fieldConfig.instantUpload)){
					fieldConfig.instantUpload = {}
				}
				if(fieldConfig.secureRoute){
					fieldConfig.instantUpload.uploaderComponentDataExtension = fieldConfig.instantUpload.uploaderComponentDataExtension || {}
					fieldConfig.instantUpload.uploaderComponentDataExtension.config = fieldConfig.instantUpload.uploaderComponentDataExtension.config || {}
					fieldConfig.instantUpload.uploaderComponentDataExtension.config.secureRoute = fieldConfig.secureRoute
					fieldConfig.instantUpload.uploaderComponentDataExtension.config.secureRouteHash = fieldConfig.secureRouteHash
				}

				this.performAndStoreAction(
					'instantMediaManagement_inEffect',
					this.prepareAction(
						instantImageUploaderController.getAction(
							fieldConfig.instantUpload.modalComponentDataExtension,
							fieldConfig.instantUpload.uploaderComponentDataExtension
						),
						undefined,
						{
							fieldConfig,
							owner,
						}
					),
					true
				)
			} else {
				this.performAndStoreAction(
					'imageManagement_inEffect',
					this.prepareAction(
						'imageManagement',
						undefined,
						{
							fieldConfig,
							listOfMediaIDs,
							owner,
						},
						{
							source: {
								load: {
									componentData: {
										model: {
											subTitle: storage.__(modalSubTitle)
										}
									}
								}
							}
						}
					)
				)
			}


		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			self.initDraggables($element);
			if(!options.refresh && self.model.indexGapFound){
				self.onChange(self.model.dataJSON);
			}
		},

		onChildChanged: function($element, options){
			if(options.fieldCode == this.model.fieldCode){
				this.onChange(options.value);
			}
		},

		async onDecision($element, options){
			let selectMedia
			let managementConfig = {}
			let modalComponent

			switch(options.decisionComponent.componentClass){
				case 'base_modal_modal':
				case 'templates_modal_modal':
					modalComponent = options.decisionComponent
					switch(options.decisionType){
						case 'decisionComponent':
						case 'submit':
							const modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
							// get selected media from mediaManagement
							if(modalContentComponent.hasClass('base_mediaManagement_image_image')){
								modalContentComponent.find('base_mediaManagement_image_imageList', imageListComponent => {
									selectMedia = imageListComponent.getSelectedMedia()
									managementConfig = imageListComponent.model.managementConfig || {}
								})
							} else if(modalContentComponent.hasClass('base_mediaManagement_imageAssignmentDetails_imageAssignmentDetails')) {
								const image = modalContentComponent.resourceData;
								this.model.dataJSON[image.index] = image;
								this.onChange(this.model.dataJSON);
								// close imageAssignmentDetails
								await modalComponent.hide();

							}
							// TODO: remove as soon as possible after downwards compatibility stuff is not needed any longer
							else if(modalContentComponent.hasClass('templates_mediaManagement_image_image')){
								modalContentComponent.find('templates_mediaManagement_image_imageList', imageListComponent => {
									selectMedia = imageListComponent.getSelectedMedia()
									managementConfig = imageListComponent.model.managementConfig || {}
								})
							} else if(modalContentComponent.hasClass('templates_mediaManagement_imageAssignmentDetails_imageAssignmentDetails')) {
								const image = modalContentComponent.resourceData;
								this.model.dataJSON[image.index] = image;
								this.onChange(this.model.dataJSON);
								// close imageAssignmentDetails
								await modalComponent.hide();
							}
							break;

						default:
							// hide imageManagement-Modal
							await modalComponent.hide();
							break;
					}
					break;

				default:
					options.decisionComponent.closest('base_modal_modal', modal => {
						modalComponent = modal
					})

					switch(options.decisionType) {
						case 'submit':
							if(utils.collectionSize(options.mediaList) > 0){
								managementConfig = (this.model.config || {}).managementConfig || {}
								selectMedia = options.mediaList
							}
							break;

						default:
							// hide imageManagement-Modal
							await modalComponent.hide();
							break;
					}
					break;
			}

			if(selectMedia){
				// set newly selected media
				if(!this.model.dataJSON) this.model.dataJSON = {};
				var mediaAdded = false;
				var mediaFound = false;
				var mediaRefreshed = false;
				var refreshNecessary = false;
				var mediaIndex;

				// mark newly added images for render process
				utils.forEach(selectMedia, image => {
					mediaFound = false;
					utils.forEach(this.model.dataJSON, (chosenImage, chosenIndex) => {
						if(chosenImage.mediaID == image.mediaID){
							mediaFound = true
							mediaIndex = chosenIndex
							return false
						}
					});

					if(mediaFound){
						if(this.model.dataJSON[mediaIndex].delete){
							mediaRefreshed = true;
							image.index = mediaIndex;
							image.delete = false;
							image.renew = true;
							refreshNecessary = true;
							this.model.dataJSON[image.index] = image;
						}
						else if(this.model.dataJSON[mediaIndex].renew){
							mediaRefreshed = true;
							image.index = mediaIndex;
							image.renew = true;
							this.model.dataJSON[image.index] = image;
						}
					}
					else {
						mediaAdded = true
						refreshNecessary = true
						image.readyToRender = true
						image.index = utils.collectionSize(this.model.dataJSON);
						this.model.dataJSON[image.index] = image;
					}
				});

				// delete elements if necessary according to managementConfig
				this.reworkImageList(managementConfig || {}, undefined, true);

				// trigger
				if(mediaAdded){
					await this.refreshOrder(true)
					// close imageManagement
					await modalComponent.hide();

					this.refresh();
				}
				else if(mediaRefreshed){
					await this.onChange(this.model.dataJSON)
					await modalComponent.hide()

					if(refreshNecessary) this.refresh();
				}
				else {
					// close imageManagement
					await modalComponent.hide();
				}
			}
		}
	}
};
